import { FiltersData, ManageAlarmsTabsEnum } from '../types';

export type ManageAlarmsState = {
    loading: boolean;
    success: boolean;
    configLoading: boolean;
    configSuccess: boolean;
    error: string;
    filters: FiltersData;
    selectedDevice?: string;
};

export const initialManageAlarms: ManageAlarmsState = {
    loading: false,
    success: false,
    configLoading: false,
    configSuccess: false,
    error: '',
    filters: {
        locationId: '',
        siteId: '',
        gatewayId: '',
        gatewayTypeId: '',
        type: ManageAlarmsTabsEnum.singlealarms,
        deviceType: '',
        alarmType: '',
    },
    selectedDevice: '',
};
